<template>
  <div class="fileCar" v-show="childFalse">
    <div class="topBox">
      <el-button @click="childback" type="">返回</el-button>
    </div>
    <div class="bottomBox">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicImgbox">
            <!-- <div class="basicImg">
            <img  src="@/assets/images/ceicon.png" />
          </div> -->
            <div class="basicName">
              <template v-for="l in dataLabes" :key="l.prop">
                <div class="basicItem" v-if="carInfoList[l.prop]">
                  <span>{{ l.label }}:</span>
                  <span>{{ carInfoList[l.prop] }}</span>
                </div>
              </template>
            </div>
          </div>
          <template v-for="item in dataLableTwo" :key="item.prop">
            <div class="basicItem">
              <span>{{ item.label }}:</span>
              <span
                v-if="
                  carInfoList.prisonInfo && carInfoList.prisonInfo[item.prop]
                "
                >{{ carInfoList.prisonInfo[item.prop] }}</span
              >
            </div>
          </template>
          <!--  -->
        </div>
      </el-card>
      <div class="rightcenter">
        <commentright
          :dialogCount="carInfoList"
          :showType="showType"
        ></commentright>
      </div>
    </div>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs, watchEffect, nextTick } from "vue";
import { carinfo } from "@/api/realHouse/realHouse.js";
import commentright from "./commentright";
export default defineComponent({
  name: "",
  components: { commentright },
  props: {
    grandsonVisible: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: String,
    },
    prisonId: {
      type: Number,
      default: 1,
    },
  },
  setup(props, context) {
    console.log("孙子 props", props);
    const data = reactive({
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      childFalse: false,
      prisonIds: 0,
      carInfoList: {},
      dataLabes: [
        {
          label: "车牌号",
          prop: "carNumber",
        },
        {
          label: "车辆品牌",
          prop: "carBrandDict",
        },
        {
          label: "车辆类型",
          prop: "carBrandDict",
        },
        {
          label: "车身颜色",
          prop: "carColorDict",
        },
        {
          label: "使用性质",
          prop: "functionDict",
        },
      ],
      dataLableTwo: [
        {
          label: "机动车所有人",
          prop: "name",
        },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        {
          label: "联系电话",
          prop: "telphone",
        },
        {
          label: "户籍行政区划",
          prop: "carNumber",
        },
        {
          label: "户籍详细地址",
          prop: "houseAddress",
        },
        {
          label: "初次登记日期",
          prop: "createTime",
        },
        {
          label: "发牌机关",
          prop: "carOffice",
        },
      ],
      childrencar: {},
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.childFalse = props.grandsonVisible;
    });
    watchEffect(() => {
      context.emit("update:grandsonVisible", data.childFalse);
    });
    // watch(
    //   () => props.prisonId,
    //   (v) => {
    //     data.prisonIds = v;
    //     if (data.childFalse) {
    //       carupdatelist();
    //     }
    //   }
    // );
    watchEffect(() => {
      if (props.prisonId) {
        data.prisonIds = props.prisonId;
        nextTick(() => {
          carupdatelist();
        });
      }
    });
    const childback = () => {
      data.childFalse = false;
      console.log("点击孙子返回data.childFalse", data.childFalse);
    };
    const carupdatelist = async () => {
      if (props.showType === "2") {
        const res = await carinfo(data.prisonIds);
        data.carInfoList = res.carInfo;
        data.childrencar = res.carInfo.prisonInfo;
        console.log(data.carInfoList);
      }
    };

    return {
      ...refData,
      childback,
    };
  },
});
</script>
<style  lang='scss' scoped >
.rightcenter {
  flex: 1;
}
.fileCar {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  .topBox {
    line-height: 66px;
    border-bottom: 1px solid #f1f2f5;
    padding: 0 20px;
  }
  .bottomBox {
    display: flex;
    flex: 1;
    overflow: auto;
  }
  .tree-card {
    height: 100%;
    width: 400px;
  }
  .basic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    .basicTitle {
      color: #000;
      line-height: 40px;
      font-weight: bold;
    }
    .basicImgbox {
      width: 100%;
      // height: 180px;
      display: flex;
      .basicImg {
        width: 110px;
        height: 100%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .basicName {
        flex: 1;
      }
    }
    .basicItem {
      flex: 1;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f1f2f5;
      padding: 10px 0;
      line-height: 24px;
      // span{
      //   // width: 206px;
      // }
    }
  }
  .center-card {
    flex: 1;
    position: relative;
    .centerbg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 386px;
      height: 386px;
      img {
        width: 100%;
        height: 100%;
      }
      .imgone {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgtwo {
        width: 75%;
        height: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgthree {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url("~@/assets/images/threeSolid/threecor.png");
        background-size: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
    }
    .centerbtn {
      width: 386px;
      height: 386px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .btnitem {
        width: 66px;
        height: 66px;
        text-align: center;
        line-height: 66px;
        border-radius: 100%;
        color: #fff;
        background: #388ff3;
        position: absolute;
        cursor: pointer;
        &:nth-child(1) {
          left: 50%;
          top: -30px;
        }
        &:nth-child(2) {
          left: 75%;
          top: 30px;
        }
        &:nth-child(3) {
          left: 90%;
          top: 50%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 83%;
        }
        &:nth-child(5) {
          left: 35%;
          bottom: -27px;
        }
        &:nth-child(6) {
          left: 20%;
          bottom: 61px;
          width: 45px;
          height: 45px;
          line-height: 42px;
        }
        &:nth-child(7) {
          left: -3%;
          bottom: 24%;
        }
        &:nth-child(8) {
          left: -1%;
          top: 110px;
        }
        &:nth-child(9) {
          left: 10%;
          top: 0px;
        }
      }
    }
  }
}
</style>